<div class="p-6 pt-4">
    <h3 class="text-xl font-bold text-shs-white-1 flex items-center gap-2">Add User</h3>
    <p class="text-xs text-font-secondary">Enter the GID and roles of the user you want to add.</p>
    <div class="grid grid-cols-2 gap-2 mt-4" [formGroup]="formGroup">
        <sag-ui-input label="GID" formControlName="gid"></sag-ui-input>
        <sag-ui-select [multiple]="true" label="Role" formControlName="roles">
            <sag-ui-option *ngFor="let role of roles | keyvalue" [value]="role.value">{{ role.value }}</sag-ui-option>
        </sag-ui-select>
        <div class="col-span-2 mt-4">
            @if (noUserFound) {
            <p class="text-shs-red text-sm mb-2">No user found with the given GID.</p>
            } @if(results.length > 0) { @for (result of results; track $index) {
            <label
                class="flex justify-between items-center rounded-md p-2 hover:bg-shs-gray-4 cursor-pointer my-1"
                [class.bg-shs-gray-4]="selectedIndex === $index"
                for="select-user-{{ $index }}"
                (click)="selectResult($index)"
            >
                <div sag-ui-avatar-base>
                    <div sag-ui-avatar>
                        {{ result.firstName[0].toUpperCase() }}{{ result.surName[0].toUpperCase() }}
                    </div>
                    <div>
                        <div sag-ui-avatar-name>{{ result.firstName }} {{ result.surName }}</div>
                        <div sag-ui-avatar-org>{{ result.department }}</div>
                    </div>
                </div>
                <sag-ui-checkbox
                    id="select-user-{{ $index }}"
                    class="pointer-events-none"
                    [checked]="selectedIndex === $index"
                    (change)="selectResult($index)"
                ></sag-ui-checkbox>
            </label>
            } } @else {
            <div sag-ui-avatar-base>
                <div sag-ui-avatar class="h-12 w-12">XX</div>
                <div>
                    <div sag-ui-avatar-name>
                        <span class="bg-shs-gray-4 h-6 w-24 m-1 block rounded-md"></span>
                        <span class="bg-shs-gray-4 h-6 w-32 m-1 block rounded-md"></span>
                    </div>
                    <div sag-ui-avatar-org>
                        <span class="bg-shs-gray-4 h-4 w-52 m-1 block rounded-md"></span>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="flex justify-end items-center gap-2 mt-8">
        <sag-ui-button color="secondary" size="sm" (click)="onClose(false)">Cancel</sag-ui-button>
        <sag-ui-button size="sm" [disabled]="invalid" (click)="onClose(true)">Save Changes</sag-ui-button>
    </div>
</div>
